import React, { useEffect, useState } from "react";
import HeaderLayout from "@layouts/withoutNaviagtion/withoutNavigationLayout";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import {
  approveExpenseReport,
  getSpecificExpenseReport,
} from "@services/expense-reports.service";
import { getValue } from "@utils/lodash";
import {
  approveExpenseReportLogin,
  getSpecificExpenseReportLogin,
} from "@services/common.service";
import { toast } from "react-toastify";
import GearLoader from "@components/common/GearLoader";
import { useNavigate } from "react-router-dom";
import ConfirmTripReportPopup from "./TripReportPopUp";

function ExpenseReportApprove(props: any) {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const urlParams = Object.fromEntries(urlSearchParams.entries());
  const params = useParams();

  const [message, setMessage] = useState<any>("");
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [reportInfo, setReportInfo] = useState();
  const [comments, setComments] = useState("");

  useEffect(() => {
    getReportData();
  }, []);

  const getReportData = async () => {
    let resp: any = await getSpecificExpenseReportLogin(
      getValue(params, `id`, ""),
      getValue(urlParams, `token`, "")
    );

    setReportInfo(getValue(resp, `data`, {}));
    if (resp?.data?.approval_status === "awaiting_approval") {
      setShowConfirmPopup(true);
    } else {
      setMessage(
        "An action has already been executed on this trip; kindly log in to review it."
      );
    }
  };

  const checkExceptionApprovalRequired = () => {
    const formInfo = reportInfo || {};
    const submittedAt = getValue(formInfo, `submitted_at`, "");
    const expenseEntries = getValue(formInfo, `expense_entries`, []);
    const exceptionLimit = getValue(
      formInfo,
      `created_by.policy.exception_approval_required_days_limit`,
      null
    );

    if (!submittedAt || expenseEntries.length === 0) {
      return { isExceeded: false, daysLimit: exceptionLimit };
    }

    const submittedDate = new Date(submittedAt);

    for (const entry of expenseEntries) {
      const expenseDate = getValue(entry, `expense_date`, "");
      if (expenseDate) {
        const expenseDateObj = new Date(expenseDate);
        const daysDifference = Math.floor(
          (submittedDate.getTime() - expenseDateObj.getTime()) /
            (1000 * 60 * 60 * 24)
        );

        if (exceptionLimit && daysDifference > exceptionLimit) {
          return { isExceeded: true, daysLimit: exceptionLimit };
        }
      }
    }

    return { isExceeded: false, daysLimit: exceptionLimit };
  };

  const { isExceeded, daysLimit } = checkExceptionApprovalRequired();

  const isExceptionallyApproved = getValue(
    props,
    `formInfo.is_exceptionally_approved`,
    false
  );
  const shouldShowExceptionLogic = isExceeded && !isExceptionallyApproved;

  const getData = async () => {
    try {
      let resp = await approveExpenseReportLogin(
        getValue(params, `id`, ""),
        getValue(urlParams, `token`, ""),
        {
          comments,
          is_exception_approval: shouldShowExceptionLogic,
        }
      );
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setMessage(getValue(resp, `message`, ""));
        setShowConfirmPopup(false);
      }
    } catch (error) {
      setMessage(error);
      setShowConfirmPopup(false);
    }
  };
  return (
    <HeaderLayout>
      {/* <div className=" d-flex align-items-center justify-content-center mt-5">
        <h6 className="header_text__18">
          Expense Report Approved Successfully
        </h6>
      </div> */}
      <ConfirmTripReportPopup
        isOpen={showConfirmPopup}
        handleApproveReject={getData}
        handleCancelModal={() => {
          setShowConfirmPopup(false);
        }}
        type={"approve the report"}
        exceptionDetails={{
          shouldShowExceptionLogic,
          daysLimit,
        }}
        comment={comments}
        setComment={setComments}
        commentsRequired={true}
      />

      <div className="d-flex h-100 w-100 align-items-center justify-content-center">
        <div className="not-found-wrapper d-flex w-100 align-items-center justify-content-center new-not-found-wrapper">
          <div className="not-found-wrapper__details text-center">
            <img
              src="/images/notfound/expenses-not-found.svg"
              className="not-found-image img-fluid trips-image"
            />
            <p className="header_text__19 text-center not-found-text">
              {message}
              <br />
              <span></span>
            </p>
          </div>
        </div>
      </div>
    </HeaderLayout>
  );
}

export default ExpenseReportApprove;
